import React from 'react';
import logo from '../assets/logo.svg';

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="h-16 flex items-center justify-center">
          <a href="/" className="inline-flex items-center gap-2" aria-label="Home">
            <img src={logo} className="h-8 w-auto" />
          </a>
        </div>
      </div>
    </header>
  )
}
